import moment from "moment";

export function convertMsToTimeseriesTimestamp(timeMs: number) {
  return moment.utc(timeMs).format("YYYY-MM-DDTHH:mm") + "Z"; // YYYY-MM-DDTHH:mmZ
}

export function convertMsToTimestampISO(timeMs: number) {
  return moment.utc(timeMs).format("YYYY-MM-DDTHH:mm:ss"); // in ISO8601
}

export function convertMsToReadableLabel(timeMs: number) {
  // "2d 13:10:12"
  const timeSeconds = Math.round(timeMs / 1000);

  const seconds = timeSeconds % 60;
  const minutes = ((timeSeconds - seconds) / 60) % 60;
  const hours = ((timeSeconds - seconds - 60 * minutes) / (60 * 60)) % 24;
  const days = (timeSeconds - seconds - 60 * minutes - 60 * 60 * hours) / (60 * 60 * 24);

  let t = `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
  if (hours > 0 || days > 0) {
    t = `${hours.toString().padStart(2, "0")}:${t}`;
    if (days > 0) {
      t = `${days}d ${t}`;
    }
  }
  return t;
}
